import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, NgModule, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { environment } from '@environment';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { ImaginarySrcModule } from '@wizbii/angular-utilities';
import { trackConversion, trackEventWithAtInternet } from '@wizbii/tracking';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-cej-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CejHeroComponent {
  heroSrc = `${environment.wizbiiImages}/cej/CEJ_banner_hero.jpg`;
  heroMobileSrc1 = `${environment.wizbiiImages}/cej/CEJ_banner_half_1.jpg`;
  heroMobileSrc2 = `${environment.wizbiiImages}/cej/CEJ_banner_half_2_new.jpg`;

  get isMobile$(): Observable<boolean> {
    return this.breakpointsService.isMobile$;
  }

  get isMobileAndTabletPortrait$(): Observable<boolean> {
    return this.breakpointsService.isMobileAndTabletPortrait$;
  }

  @Output() click: EventEmitter<void> = new EventEmitter();

  constructor(private readonly breakpointsService: BreakpointsService) {}

  heroButtonClicked(): void {
    this.trackEvent();
    this.click.emit();
  }

  private trackEvent(): void {
    trackEventWithAtInternet({ category: 'CEJ', action: 'Click Je me lance', label: 'top', type: 'action' });

    if (environment.platform === 'prod') {
      trackConversion({
        send_to: 'DC-3048978/emplo253/btncej+standard',
        allow_custom_scripts: true,
      });
    }
  }
}

@NgModule({
  imports: [CommonModule, MatIconModule, ImaginarySrcModule, ScrollToModule],
  declarations: [CejHeroComponent],
  exports: [CejHeroComponent],
})
export class CejHeroModule {}
